import styled from "styled-components";

export const LoaderContainer = styled.div `
    .spinner {
        width: 40px;
        height: 40px;
    
        position: relative;
        margin: ${props => props.margin || "100px auto"};
    }
    
    .double-bounce1, .double-bounce2 {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #666;
        opacity: 0.6;
        position: absolute;
        top: op0;
        left: 0;
        
        -webkit-animation: bounce 2.0s infinite ease-in-out;
        animation: bounce 2.0s infinite ease-in-out;
    }
    
    .double-bounce2 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
    }
    
    @-webkit-keyframes bounce {
        0%, 100% { -webkit-transform: scale(0.0) }
        50% { -webkit-transform: scale(1.0) }
    }
    
    @keyframes bounce {
        0%, 100% { 
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
        } 50% { 
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
        }
    }
`